import { type Membership, membershipSchema } from '@ytclip/shared'
import { apiRequest } from '@/lib/api-client.ts'

export function fetchMembership(): Promise<Membership> {
  return apiRequest('/me/membership', membershipSchema)
}
